<template>
    <h3 class="mb-0">{{ title }}</h3>
    <jet-button
        v-if="!!href && showAction"
        style="min-width: 0"
        type="button"
        variant="secondary"
        @click.stop="onClick ? onClick() : $inertia.visit(href)"
    >
        <slot name="label">
            <span v-if="label">{{ label }}</span>
            <span v-if="label && actionIcon" style="color: #e4e5e6">|</span>
            <icon v-if="actionIcon" :icon="actionIcon" />
        </slot>
    </jet-button>
</template>
<script setup>
import Icon from '@/Components/Icon.vue';
import JetButton from '@/Jetstream/Button.vue';

const props = defineProps({
    title: String,
    label: String,
    href: String,
    icon: String,
    actionIcon: String,
    showAction: Boolean,
    onClick: Function,
});
</script>
<style scoped>
:deep(.disabled a) {
    color: #ccc;
}
</style>
